import angular from 'angular';
import uiRouter from 'angular-ui-router';
import amendComponent from './amend.component';
import myBookingApi from '../../../../api/mybooking/mybooking';
import cacheService from '../../../../services/cache.service';
import splitTranslationWithLink from '../../../../common/filters/extractAndCreateTranslationLink';

const amendModule = angular.module('amend', [
    uiRouter,
    myBookingApi,
    cacheService,
    splitTranslationWithLink
])
    .config(($stateProvider) => {
        "ngInject";
        $stateProvider
            .state('bookings.booking.amend', {
                url: '/amend',
                resolve: {
                    data: function (myBookingService, $stateParams, $q, authService, $state) {
                        return $q.all({
                            amend: myBookingService.getAmend($stateParams.bookingReference),
                            cancel: myBookingService.getCancel($stateParams.bookingReference)
                        }).then((result) => {
                            for (var id in result.amend.transfers) {
                                angular.merge(result.amend.transfers[id], result.cancel.transfers[id]);
                            }
                            return result.amend;
                        }, function (error) {
                            if (error.status === 401) {
                                authService.clearSession();
                                $state.go('auth.login');
                            }
                            return null;
                        });
                    }
                },
                views: {
                    'booking@bookings.booking': {
                        template: '<amend amend="$resolve.data"></amend>'
                    }
                }
            })
    })
    .component('amend', amendComponent)
    .name

export default amendModule


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/amend/amend.js